export default {"src":"/_next/static/media/sent-testimony.2c7a5267.svg","height":367,"width":334,"blurWidth":0,"blurHeight":0};